import { ApolloClient, ApolloLink, createHttpLink, from } from '@apollo/client';
import buildCache from './cache.js';
import typeDefs from './clientSchema.js';
import { getAccessToken } from '../utils/auth.js';
import { LoaderLink } from './apolloLinks/LoaderLink.js';
import { getErrorLink } from './apolloLinks/errorLink/getErrorLink.js';
import {
  secondsToExpire,
  STORAGE_KEYS
} from '../features/timeoutWarning/services/secondsToExpireCache';
import { clearGlobalReactiveVar, setGlobalReactiveVar } from '@apollo-internal/globalReactiveVar';

let client;

const initClient = loaderControls => {
  const httpLink = createHttpLink({
    uri: process.env.API_BASE_URL + '/appraisal-data'
  });

  const authLink = new ApolloLink((operation, forward) => {
    const token = getAccessToken();
    operation.setContext(({ headers }) => ({
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : ''
      }
    }));
    return forward(operation);
  });

  const sessionLink = new ApolloLink((operation, forward) => {
    return forward(operation).map(response => {
      if (response.data && response.data.secondsToExpire) {
        setGlobalReactiveVar(secondsToExpire, STORAGE_KEYS.SESSION_DURATION, {
          seconds: response.data.secondsToExpire,
          date: Date.now()
        });
        delete response.data.secondsToExpire;
      } else {
        clearGlobalReactiveVar(secondsToExpire, STORAGE_KEYS.SESSION_DURATION);
      }
      return response;
    });
  });

  return new ApolloClient({
    link: from([
      new LoaderLink(loaderControls),
      getErrorLink(clientProvider),
      authLink,
      sessionLink,
      httpLink
    ]),
    cache: buildCache(),
    typeDefs
  });
};

const clientProvider = () => client;

/**
 * Gets or creates the Apollo client
 * @return {*}
 */
const getApolloClient = loaderControls => {
  const _client = client ? client : initClient(loaderControls);
  if (!client) client = _client;

  return client;
};

export default getApolloClient;
